import { Loading, Notification } from "@quark/design";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserInfo, postLogin } from "../../api";
import styles from "./index.module.scss";
import useDocumentTitle from "../../hooks/use-document-title";

const Login = () => {
  useDocumentTitle("登录");
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);

  const login = () => {
    if (loading) return;
    const params = {
      name: name.trim(),
      pwd: pwd.trim(),
    };
    if (!params.name || !params.pwd) {
      Notification.error("用户名或密码不能为空", { duration: 3000 });
      return;
    }
    setLoading(true);
    postLogin(params)
      .then(() => {
        navigate("/");
      })
      .catch((_e) => {
        Notification.error("用户名或密码错误", { duration: 3000 });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getUserInfo().then((res) => {
      if (res.is_login) {
        navigate("/");
      }
    });
  }, [navigate]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>
          <div className={styles.logo}></div>
          PythonTip
        </div>

        <div className={styles.field}>
          <div className={styles.label}>用户名</div>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className={styles.field}>
          <div className={styles.label}>密码</div>
          <input
            type="password"
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
          />
        </div>

        <div className={styles.button} onClick={login}>
          {loading ? <Loading /> : "登陆"}
        </div>
      </div>
    </div>
  );
};

export default Login;
